import { Typography, Box } from "@mui/material";
import { Cottage } from "@mui/icons-material";
import { TextContent } from "./ApartmentsHelpers";

export const DefaultContent = ({ item }) => {
    return (
        <TextContent>
            <Box display="flex" alignItems="center" mb={2}>
                <Cottage
                    color="primary"
                    fontSize="medium"
                    sx={{ mr: 1, mt: '-2px' }}
                />
                <Typography variant="h2">{item.name}</Typography>
            </Box>
            <Typography mb={2}>{item.address}</Typography>
            <Typography>Договор управления: № {item.contract_num}</Typography>
            <Typography>
                Процент владения: {parseInt(item.interest, 10) * 100} %
            </Typography>
            <Typography>
                Площадь объекта: {item.totalArea != null ? item.totalArea + " м²" : "-"}
            </Typography>
        </TextContent>
    );
};
